import AccessTimeIcon from "@mui/icons-material/AccessTime";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
    Breadcrumbs,
    Button,
    Card,
    CardContent,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    Link,
    MenuItem,
    Paper,
    Select,
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import AodIcon from "@mui/icons-material/Aod";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import { useDispatch, useSelector } from "react-redux";
import RcsDeliveredIcon from "../../../assets/icons/rcs-delivered-icon";
import RcsReadIcon from "../../../assets/icons/rcs-read-icon";
import RcsSentIcon from "../../../assets/icons/rcs-sent-icon";
import RCSLogo from "../../../assets/icons/RCSLogo.png";
import SmsLogo from "../../../assets/icons/smsLogo.png";
import {
    ERoles,
    getColourByMessageStatus,
    getStatusToDisplay,
    messageLastStatus,
    MessageStatus,
    TemplateStatus,
    TemplateTypes,
    toUtcEndOfDay,
    toUtcStartOfDay,
} from "../../../config";
import { setApiBotStatusReport, setApiBotStatusReportLoading } from "../../../redux/apiReportManagement/apiReportManagementSlice";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import TablePaginationShowPage from "../../../utils/tablePagination";
import FetchingSpinner from "../../components/FetchingSpinner";
import NoRecords from "../../components/NoRecords";
import CampaignSimulator from "../simulatorComponents/ReportSimulator";

import { BlockOutlined, Cached, Download } from "@mui/icons-material";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import { tooltipClasses } from "@mui/joy";
import moment from "moment/moment";
import AlertMessageComponent from "../../components/AlertMessageComponent";
import DownloadIcon from "@mui/icons-material/Download";
import { setErroMessageForField } from "../../../redux/campaignManagment/campaignManagmentSlice";
import useAuth from "../../../hooks/useAuth";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: "14px !important",
        fontWeight: "bold",
        backgroundColor: "#f4f4f4",
        padding: "5px 15px !important",
        // color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: "13px !important",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // "&:nth-of-type(odd)": {
    //     backgroundColor: theme.palette.action.hover,
    // },

    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const BootstrapTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

const calculateTime = value => {
    const time = new Date(value).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
    const day = new Date(value).toLocaleDateString([], { day: "2-digit" });
    const month = new Date(value).toLocaleDateString([], { month: "2-digit" });
    const year = new Date(value).toLocaleDateString([], { year: "numeric" });

    return `${day}-${month}-${year} , ${time}`;
};

export const MessageStatusForCount = {
    Failed: "FAILED",
    Read: "READ",
    Delivered: "DELIVERED",
    Sent: "SENT",
    Retry: "RETRY",
    Pending: "PENDING",
    TTLExpirationRevoked: "TTL_EXPIRATION_REVOKED",
    Sms: "SMS",
    TotalCount: "TOTAL_COUNT",
    CampaignLastTime: "CAMPAIGN_LAST_TIME",
    CampaignFirstTime: "CAMPAIGN_FIRST_TIME",
    TotalSMSCount: "TOTAL_SMS",
    TotalRCSCount: "TOTAL_RCS",
    SmsDELIVERED: "SMS-DELIVERED",
    TotalSMSFailed: "TOTAL_SMS_FAILED",
};

export default function ViewBotApiReport({ selectedBot, setShowBotReport }) {
    const [totalCountPageSize, setTotalCountPageSize] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [apiBotReportListLoader, setApiBotReportListLoader] = useState(false);
    const [apiBotReportList, setApiBotReportList] = useState([]);
    const [showApiBotSimulator, setShowApiBotSimulator] = useState(false);
    const [apiBotMessageDetails, setApiBotMessageDetails] = useState({});
    const [loadDownload, setLoadDownload] = useState(false);
    const [loadDownloadAnalytics, setLoadDownloadAnalytics] = useState(false);
    const [templateList, setTemplateList] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(false);
    const [botAPISuggestionButtonClick, setBotAPISuggestionButtonClick] = useState(0);

    const { user } = useAuth();
    const isSuperAdmin = user?.roleName === ERoles.SUPER_ADMIN ?? false;
    const orglevelLinkAnalyticsPermission = user?.organizationPrivileges?.IS_LINK_ANALYTICS_ENABLED?.value ?? false;
    const shouldShowLinkAnalyticsBtn = isSuperAdmin === true || orglevelLinkAnalyticsPermission === true;

    let endDate = dayjs();
    let startDate = dayjs();
    // new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    // endDate = moment(endDate).format('YYYY-MM-DD');
    // startDate = moment(startDate).format("YYYY-MM-DD");
    const [searchParams, setSearchParams] = useState({
        startDate,
        endDate,
    });
    // const searchRecipientNumber = useDebounce(searchParams, 1000);
    const [reload, setReload] = useState(true);
    const [error, setError] = useState({ exists: false, message: "" });
    const state = useSelector(state => state.apiReportsManagementSlice);
    const [botAPISuggestionButtonRCSLoading, setBotAPISuggestionButtonRCSLoading] = useState(false);
    const dispatch = useDispatch();

    const [counts, setCounts] = useState({
        totalSubmitted: 0,
        totalSentRCS: 0,
        totalDelivered: 0,
        totalRead: 0,
        totalFailed: 0,
        totalClicks: 0,
    });

    const [loading, setLoading] = useState(false);

    const getApiReportForBot = async () => {
        try {
            setLoading(true);
            const botId = selectedBot.config.rbmClientId;

            const start = new Date(searchParams.startDate);

            const end = new Date(searchParams.endDate);

            const dateRange = {
                startDate: start.toISOString().split("T")[0], // Send full ISO strings to include time
                endDate: end.toISOString().split("T")[0],
            };

            const response = await apiGatewayAxiosInstance.post(`mis_server/master-mis/get-count-reports`, {
                botId: botId,
                templateId: searchParams.templateId,
                dateRange,
                correlationId: true,
            });

            setCounts(response.data);
            // setApiBotStatusReport({ ...apiBotStatusReport, ...response.data.apiBotReportDetails })
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };

    const onChangeSelectTemplate = async e => {
        const template = e.target.value;
        setSelectedTemplate(template);
        const templateId = template._id;
        setSearchParams({ ...searchParams, templateId });
    };

    const getApiBotReportDetailsByPageSize = async (pageSize, currentPage) => {
        try {
            // setLoader(true)
            setApiBotReportListLoader(true);
            // const token = sessionStorage.getItem("accessToken");
            const botId = selectedBot.config.rbmClientId;
            const response = await apiGatewayAxiosInstance.get(`/conversation_logger/api-logger/get-bot-reports-details-page-size-by-botId`, {
                params: {
                    // campaignId: campaigndetails._id,
                    pageSize,
                    currentPage: currentPage + 1,
                    messageStatus: searchParams.messageStatus,
                    userNumber: searchParams.userNumber,
                    startDate: moment(new Date(searchParams.startDate)).format("YYYY-MM-DD"),
                    templateName: searchParams.TemplateName,
                    templateId: searchParams.templateId,
                    endDate: moment(new Date(searchParams.endDate)).format("YYYY-MM-DD"),

                    botId,
                    // sendTime: "",
                    provider: searchParams.provider,
                },
            });

            setApiBotReportList(response.data.reportDetails);

            setTotalCountPageSize(response.data.totalCount);
        } catch (error) {
            let errorMessage = "Server not reachable";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            }
            dispatch(
                setErroMessageForField({
                    fieldName: "getCampaignReportCSVDataErrorMessage",
                    errorMessage,
                }),
            );
        }
        setApiBotReportListLoader(false);
    };

    const onClickCancel = () => {
        setShowBotReport(false);
    };

    const onClickSearch = () => {
        setReload(!reload);
    };

    const getTemplatesByBotId = async botId => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/bot_management/template/get-all-templates-by-botid`, { params: { botid: botId } });
            if (response.status === 200) {
                setTemplateList(response.data);
                return;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleClickDownloadReport = async (includeIp = false) => {
        try {
            // setApiBotReportListLoader(true)
            if (includeIp) {
                setLoadDownloadAnalytics(true);
            } else {
                setLoadDownload(true);
            }

            let suggestionsTextList = [];
            switch (selectedTemplate.templateType) {
                case TemplateTypes.TEXT_MESSAGE:
                    if (selectedTemplate.textMessageDetails.suggestionsList && selectedTemplate.textMessageDetails.suggestionsList.length > 0) {
                        for (let index = 0; index < selectedTemplate.textMessageDetails.suggestionsList.length; index++) {
                            const element = selectedTemplate.textMessageDetails.suggestionsList[index];
                            suggestionsTextList.push(`${element.suggestionText.replace(/\./g, "")}_1_${index + 1}`);
                        }
                    }
                    break;
                case TemplateTypes.RICH_CARD:
                    if (
                        selectedTemplate.richCardStandAloneDetails.suggestionsList &&
                        selectedTemplate.richCardStandAloneDetails.suggestionsList.length > 0
                    ) {
                        for (let index = 0; index < selectedTemplate.richCardStandAloneDetails.suggestionsList.length; index++) {
                            const element = selectedTemplate.richCardStandAloneDetails.suggestionsList[index];
                            suggestionsTextList.push(`${element.suggestionText.replace(/\./g, "")}_1_${index + 1}`);
                        }
                    }

                    break;
                case TemplateTypes.CAROUSEL:
                    for (let cardIndex = 0; cardIndex < selectedTemplate.richCardCarouselDetails.cardsList.length; cardIndex++) {
                        const card = selectedTemplate.richCardCarouselDetails.cardsList[cardIndex];
                        for (let index = 0; index < card.suggestionsList.length; index++) {
                            const element = card.suggestionsList[index];
                            suggestionsTextList.push(`${element.suggestionText.replace(/\./g, "")}_${cardIndex + 1}_${index + 1}`);
                        }
                    }
                    break;

                default:
                    break;
            }

            const botId = selectedBot.config.rbmClientId;
            const response = await apiGatewayAxiosInstance.post(
                `/conversation_logger/api-logger/download-api-bot-report`,
                {
                    // pageSize,
                    // currentPage: currentPage + 1,
                    messageStatus: searchParams.messageStatus,
                    userNumber: searchParams.userNumber,
                    suggestionsTextList,
                    templateName: searchParams.TemplateName,
                    templateId: searchParams.templateId,
                    startDate: searchParams.startDate,
                    endDate: searchParams.endDate,
                    botId,
                    provider: searchParams.provider,
                },
                {
                    params: {
                        includeIp: includeIp,
                    },
                },
            );

            if (response.status === 200) {
                const csvBlob = new Blob([response.data], {
                    type: "text/csv",
                });
                const csvUrl = URL.createObjectURL(csvBlob);

                const link = document.createElement("a");
                link.href = csvUrl;
                link.setAttribute("download", `apiReport.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                throw new Error(response.data);
            }
            setLoadDownload(false);
            setLoadDownloadAnalytics(false);
        } catch (error) {
            // setApiBotReportListLoader(false);
            setLoadDownload(false);
            setLoadDownloadAnalytics(false);
            let errorMessage = "Failed to Download Bot API Report.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setError({ exists: true, message: errorMessage });
        }
    };

    const ViewApiBotSimulator = apiBotDetails => {
        setApiBotMessageDetails(apiBotDetails);
        setShowApiBotSimulator(true);
    };

    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
        getApiBotReportDetailsByPageSize(parseInt(event.target.value), 0);
    };
    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
        getApiBotReportDetailsByPageSize(pageSize, newPage);
    };

    const handleChangeSearch = ({ name, value }) => {
        setSearchParams({ ...searchParams, [name]: value });
    };
    const onClickClear = () => {
        const endDateforClear = endDate;
        const startDateForClear = startDate;
        setSearchParams({
            TemplateName: "",
            messageStatus: "",
            provider: "",
            startDate: startDateForClear,
            endDate: endDateforClear,
            userNumber: "",
        });
        reloadList();
    };

    const reloadList = () => {
        setReload(!reload);
    };
    useEffect(() => {
        setCurrentPage(0);
        getApiBotReportDetailsByPageSize(pageSize, 0);
        getApiReportForBot();
    }, [reload]);

    useEffect(() => {
        getTemplatesByBotId(selectedBot._id);
    }, []);

    const handleEndDateChange = date => {
        setSearchParams(prev => ({ ...prev, endDate: date }));
    };

    const handleStartDateChange = date => {
        setSearchParams(prev => ({ ...prev, startDate: date }));
    };
    return (
        <Grid>
            <Grid container className="listHeader" mb={2}>
                <Grid item md={6} display={"flex"} alignItems={"center"}>
                    <IconButton color="secondary" onClick={onClickCancel} size="medium">
                        <ArrowBackIosIcon sx={{ cursor: "pointer" }} />
                    </IconButton>
                    <Grid
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                        gap={2}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Breadcrumbs aria-label="breadcrumb" fontSize="large">
                                <Link
                                    underline="hover"
                                    color="inherit"
                                    className="breadcrumbItem"
                                    // href="/rcs-management/manage-bots/"
                                    onClick={onClickCancel}
                                >
                                    API Report
                                </Link>
                                <Typography className="breadcrumbItem" color="text.primary">
                                    {selectedBot.botName} API Report
                                </Typography>
                            </Breadcrumbs>
                        </Grid>
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <IconButton
                                title="Refresh"
                                onClick={reloadList}
                                sx={{
                                    animation: loading || apiBotReportListLoader ? "spin 0.5s linear infinite" : "",
                                    "@keyframes spin": {
                                        "0%": {
                                            transform: "rotate(360deg)",
                                        },
                                        "100%": {
                                            transform: "rotate(0deg)",
                                        },
                                    },
                                    // marginInline: "20px",
                                }}
                            >
                                <Cached />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Card className="border border-secondary-50">
                <CardContent>
                    <Grid
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            placeContent: "space-between",
                        }}
                    >
                        <Grid container sx={{ display: "flex", gap: 2, margin: "10px" }}>
                            <Grid item maxWidth={"140px"}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="From Date"
                                        value={searchParams.startDate}
                                        format="DD-MM-YYYY"
                                        name="startDate"
                                        onChange={handleStartDateChange}
                                        renderInput={params => <TextField {...params} fullWidth />}
                                        disableFuture
                                        minDate={dayjs("2024-09-01")}
                                        maxDate={searchParams.endDate}
                                    />
                                </LocalizationProvider>
                                {/* <TextField
                                    fullWidth
                                    type="date"
                                    label="Start Date"
                                    name="startDate"
                                    value={searchParams.startDate}
                                    onChange={(e) => handleChangeSearch(e.target)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                /> */}
                            </Grid>
                            <Grid item maxWidth={"140px"}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="To Date"
                                        value={searchParams.endDate}
                                        format="DD-MM-YYYY"
                                        name="endDate"
                                        onChange={handleEndDateChange}
                                        renderInput={params => <TextField {...params} fullWidth />}
                                        disableFuture
                                        minDate={searchParams.startDate}
                                        maxDate={dayjs()}
                                    />
                                </LocalizationProvider>
                                {/* <TextField
                                    fullWidth
                                    type="date"
                                    label="End Date"
                                    name="endDate"
                                    value={searchParams.endDate}
                                    onChange={(e) => handleChangeSearch(e.target)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                /> */}
                            </Grid>
                            <Grid item>
                                {/* <TextField
                                    value={searchParams.TemplateName}
                                    name="TemplateName"
                                    onChange={(e) => handleChangeSearch(e.target)}
                                    label="Template Name"
                                    fullWidth
                                    placeholder="Enter Template Name"
                                /> */}

                                <FormControl sx={{ minWidth: 160 }}>
                                    <InputLabel id="select-template-label">Select Template</InputLabel>
                                    <Select
                                        fullWidth
                                        value={selectedTemplate}
                                        onChange={onChangeSelectTemplate}
                                        label="Select Template"
                                        labelId="select-template-label"
                                        id="select-template-label"
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    overflow: "scroll",
                                                    maxHeight: "40%",
                                                    boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                                                    alignItems: templateList.length > 0 ? "unset" : "center",
                                                    // display: "flex",
                                                    justifyContent: templateList.length > 0 ? "unset" : "center",
                                                },
                                            },
                                        }}
                                    >
                                        {templateList.length > 0 ? (
                                            templateList.map((template, index) => {
                                                if (template.status === "approved")
                                                    return <MenuItem value={template}>{template.templateName}</MenuItem>;
                                            })
                                        ) : (
                                            <MenuItem disabled>
                                                <Typography variant="h5">template not found</Typography>
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <TextField
                                    value={searchParams.userNumber}
                                    name="userNumber"
                                    onChange={e => handleChangeSearch(e.target)}
                                    label="User Number"
                                    fullWidth
                                    placeholder="Enter User Number"
                                />
                            </Grid>
                            <Grid item>
                                <FormControl sx={{ minWidth: 80 }}>
                                    <InputLabel id="demo-controlled-open-select-label">Status</InputLabel>
                                    <Select
                                        labelId="demo-controlled-open-select-label"
                                        id="demo-controlled-open-select"
                                        name="messageStatus"
                                        value={searchParams.messageStatus ? `${searchParams.messageStatus}` : ""}
                                        label="Status"
                                        onChange={e => handleChangeSearch(e.target)}
                                    >
                                        {/* <MenuItem value={MessageStatus.Retry}>
                                            {MessageStatus.Retry}
                                        </MenuItem> */}
                                        <MenuItem value={MessageStatus.Failed}>{MessageStatus.Failed}</MenuItem>
                                        <MenuItem value={MessageStatus.Delivered}>{MessageStatus.Delivered}</MenuItem>
                                        <MenuItem value={MessageStatus.Pending}>{MessageStatus.Pending}</MenuItem>
                                        <MenuItem value={MessageStatus.Sent}>{MessageStatus.Sent}</MenuItem>
                                        <MenuItem value={MessageStatus.Read}>{MessageStatus.Read}</MenuItem>
                                        <MenuItem value={MessageStatus.TTLExpirationRevoked}>{MessageStatus.TTLExpirationRevoked}</MenuItem>
                                        <MenuItem value={MessageStatus.DELIVRD}>{getStatusToDisplay(MessageStatus.DELIVRD)}</MenuItem>
                                        <MenuItem value={MessageStatus.SMSFailed}>{getStatusToDisplay(MessageStatus.SMSFailed)}</MenuItem>
                                        {/* <MenuItem value={""}>All</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <FormControl sx={{ minWidth: 100 }}>
                                    <InputLabel id="demo-simple-select-helper-label">Provider</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        name="provider"
                                        value={searchParams.provider ? `${searchParams.provider}` : ""}
                                        label="Provider"
                                        onChange={e => handleChangeSearch(e.target)}
                                    >
                                        {["VI", "SMS"].map(provider => (
                                            <MenuItem key={provider} value={provider}>
                                                {provider}
                                            </MenuItem>
                                        ))}
                                        {/* <MenuItem key={"all"} value={""}>All</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {searchParams.startDate > searchParams.endDate ? (
                                    <BootstrapTooltip title="Start Date cannot be greater than End Date!">
                                        <Button onClick={() => onClickSearch()} aria-label="sent" color="primary" variant="contained" disabled={true}>
                                            Search{" "}
                                            {apiBotReportListLoader && <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />}
                                        </Button>
                                    </BootstrapTooltip>
                                ) : (
                                    <Button
                                        onClick={() => onClickSearch()}
                                        aria-label="sent"
                                        color="primary"
                                        variant="contained"
                                        disabled={apiBotReportListLoader}
                                    >
                                        Search {apiBotReportListLoader && <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />}
                                    </Button>
                                )}
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Button onClick={onClickClear} aria-label="sent" variant="contained" color="error" disabled={apiBotReportListLoader}>
                                    Clear
                                </Button>
                            </Grid>
                            {/* <Grid item
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    sx={{
                                        marginRight: "10px",
                                        whiteSpace: "nowrap"
                                    }}
                                    // variant="outlined"
                                    onClick={handleClickDownloadReport}
                                    disabled={loadDownload}
                                >
                                    {loadDownload ? <CircularProgress size={15} className='spinner' /> : <DownloadIcon />}
                                    &nbsp; Download Report
                                </Button>
                            </Grid> */}
                        </Grid>
                    </Grid>

                    <Grid display={"flex"} justifyContent={"space-between"}>
                        <Grid>
                            <Grid
                                container
                                md={12}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap !important",
                                }}
                                gap={5}
                            >
                                RCS :
                                <Grid item>
                                    <Grid
                                        item
                                        md={12}
                                        sx={{
                                            display: "flex",
                                            // justifyContent: "space-between",
                                            alignItems: "center",
                                            flexWrap: "wrap !important",
                                        }}
                                        gap={5}
                                    >
                                        <Grid>
                                            <Typography
                                                sx={{
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <Grid display="flex" flexDirection={"row"}>
                                                    TOTAL :{" "}
                                                    {loading ? (
                                                        <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                    ) : (
                                                        counts["totalSubmitted"]
                                                    )}
                                                </Grid>
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center !important",
                                            }}
                                        >
                                            <Typography
                                                color="orange"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <AccessTimeIcon fontSize="small" sx={{ margin: "5px" }} />
                                                PENDING :{" "}
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalPending"]
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <Typography
                                                color="primary"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {/* <DoneIcon fontSize="small" sx={{ margin: "5px" }} /> */}
                                                <RcsSentIcon />
                                                SENT :{" "}
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalSentRCS"]
                                                )}
                                            </Typography>
                                        </Grid>

                                        <Grid>
                                            <Typography
                                                color="green"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {/* <DoneAllIcon fontSize="small" sx={{ margin: "5px" }} /> */}
                                                <RcsDeliveredIcon />
                                                DELIVERED :{" "}
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalDelivered"]
                                                )}
                                                {/* {
                                    campaignReports.filter(
                                        (campaignReport) =>
                                            campaignReport.statusWithTime['DELIVERED']
                                    ).length
                                } */}
                                            </Typography>
                                        </Grid>

                                        <Grid>
                                            <Typography
                                                color="darkblue"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {/* <RemoveRedEyeIcon fontSize="small" sx={{ margin: "5px" }} /> */}
                                                <RcsReadIcon />
                                                READ :
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalRead"]
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <Typography
                                                color={"GrayText"}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <BlockOutlined fontSize="small" sx={{ margin: "5px" }} />
                                                RCS Disabled :{" "}
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    (counts["totalDisableFailed"] ?? "-")
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <Typography
                                                color="error"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <UnpublishedIcon fontSize="small" sx={{ margin: "5px" }} />
                                                FAILED :{" "}
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalFailed"]
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <Typography
                                                color="GrayText"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <CurrencyExchangeIcon fontSize="small" sx={{ margin: "5px" }} />
                                                Sent Revoked :{" "}
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalSentRevokedRCS"]
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <Typography
                                                color="#9003fc"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center !important",
                                                    fontSize: "0.7rem !important",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <CurrencyExchangeIcon fontSize="small" sx={{ margin: "5px" }} />
                                                CLICKS :
                                                {loading ? (
                                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                                ) : (
                                                    counts["totalClicks"]
                                                )}
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    {/* ====================================================== sms =======================================================  */}
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                md={12}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap !important",
                                }}
                                gap={5}
                            >
                                SMS :
                                <Grid>
                                    <Typography
                                        sx={{
                                            fontSize: "0.7rem !important",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <Grid display="flex" flexDirection={"row"}>
                                            TOTAL :{" "}
                                            {loading ? (
                                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                            ) : (
                                                counts["totalSMS"]
                                            )}
                                        </Grid>
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <Typography
                                        color="primary"
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center !important",
                                            fontSize: "0.7rem !important",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <RcsSentIcon />
                                        SENT :{" "}
                                        {loading ? (
                                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                        ) : (
                                            counts["totalSentSMS"]
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <Typography
                                        color="green"
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center !important",
                                            fontSize: "0.7rem !important",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <RcsDeliveredIcon />
                                        DELIVERED :{" "}
                                        {loading ? (
                                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                        ) : (
                                            counts["totalSMSDelivered"]
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <Typography
                                        color="error"
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center !important",
                                            fontSize: "0.7rem !important",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <UnpublishedIcon fontSize="small" sx={{ margin: "5px" }} />
                                        Failed :{" "}
                                        {loading ? (
                                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                        ) : (
                                            counts["totalSMSFailed"]
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid display={"flex"} gap={3}>
                        <Grid display={"flex"}>
                            <Button variant="outlined" onClick={() => handleClickDownloadReport(false)} disabled={loadDownload}>
                                {loadDownload ? <CircularProgress size={15} className="spinner" /> : <DownloadIcon />}
                                &nbsp; Download Report
                            </Button>
                        </Grid>

                        {shouldShowLinkAnalyticsBtn && (
                            <Grid display={"flex"}>
                                <Button variant="outlined" onClick={() => handleClickDownloadReport(true)} disabled={loadDownloadAnalytics}>
                                    {loadDownloadAnalytics ? <CircularProgress size={15} className="spinner" /> : <DownloadIcon />}
                                    &nbsp; Download Link Tracking Report
                                </Button>
                            </Grid>
                        )}
                    </Grid>

                    {apiBotReportListLoader ? (
                        <FetchingSpinner />
                    ) : apiBotReportList && apiBotReportList.length > 0 ? (
                        <>
                            <TableContainer
                                component={Paper}
                                className="table-container"
                                sx={{ borderRadius: "10px  !important", maxHeight: "60vh" }}
                            >
                                <Table size="small" stickyHeader sx={{}}>
                                    <TableHead className="row">
                                        <TableRow>
                                            <StyledTableCell className="tableContentFont" align="center">
                                                Sr No
                                            </StyledTableCell>
                                            <StyledTableCell className="tableContentFont" align="center">
                                                <Typography variant>Users</Typography>
                                            </StyledTableCell>

                                            <StyledTableCell className="tableContentFont" align="center">
                                                Send Time
                                            </StyledTableCell>
                                            <StyledTableCell className="tableContentFont" align="center">
                                                Provider
                                            </StyledTableCell>
                                            <StyledTableCell className="tableContentFont" align="center">
                                                Reason
                                            </StyledTableCell>

                                            <StyledTableCell className="tableContentFont" align="center">
                                                Message Status
                                            </StyledTableCell>
                                            <StyledTableCell className="tableContentFont" align="center">
                                                Actions
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* {campaignReports.slice(currentPage * pageSize, currentPage * pageSize + pageSize).map((campaignReport, index) => ( */}
                                        {apiBotReportList.map((apiBotReport, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    <b>{currentPage * pageSize + index + 1}</b>
                                                </StyledTableCell>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {apiBotReport?.receiverNumber}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {apiBotReport?.statusWithTime?.["PENDING"]
                                                        ? calculateTime(apiBotReport?.statusWithTime?.["PENDING"])
                                                        : apiBotReport?.statusWithTime?.["SENT"]
                                                          ? calculateTime(apiBotReport?.statusWithTime?.["SENT"])
                                                          : apiBotReport?.statusWithTime?.["FAILED"]
                                                            ? calculateTime(apiBotReport?.statusWithTime?.["FAILED"])
                                                            : apiBotReport?.statusWithTime?.["SMS-FAILED"]
                                                              ? calculateTime(apiBotReport?.statusWithTime?.["SMS-FAILED"])
                                                              : calculateTime(apiBotReport?.createdAt)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {apiBotReport?.provider.toLowerCase() !== "sms" && (
                                                        <img src={RCSLogo} height={"20px"} width={"20px"} title={apiBotReport?.provider} />
                                                    )}
                                                    {apiBotReport?.provider.toLowerCase() === "sms" && (
                                                        <img src={SmsLogo} height={"20px"} width={"20px"} title={apiBotReport?.provider} />
                                                    )}
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {/* {apiBotReport?.reason ?? "-"} */}

                                                    <Tooltip
                                                        title={<p style={{ fontSize: ".7rem" }}>{apiBotReport?.reason} </p>}
                                                        className="cursor-pointer"
                                                    >
                                                        {apiBotReport?.reason
                                                            ? apiBotReport?.reason.length > 75
                                                                ? `${apiBotReport?.reason.substr(0, 75)}...`
                                                                : apiBotReport?.reason
                                                            : "-"}
                                                    </Tooltip>
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {/* {campaignReport?.statusWithTime && messageLastStatus(campaignReport?.statusWithTime)} */}
                                                    <Typography variant="subtitle2" color={getColourByMessageStatus(apiBotReport?.statusWithTime)}>
                                                        {messageLastStatus(apiBotReport?.statusWithTime)}
                                                        {/* <br />
                                                    {campaignReport.messageStatus} */}
                                                    </Typography>
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="center">
                                                    <Grid
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        {apiBotReport.messagePayload && (
                                                            <IconButton title="View Message" onClick={() => ViewApiBotSimulator(apiBotReport)}>
                                                                <AodIcon />
                                                            </IconButton>
                                                        )}

                                                        {apiBotReport?.statusWithTime && (
                                                            <Tooltip
                                                                sx={{
                                                                    paddingLeft: 2,
                                                                }}
                                                                title={
                                                                    <p
                                                                        style={{
                                                                            fontSize: ".7rem",
                                                                        }}
                                                                    >
                                                                        {Object.values(MessageStatus).map(status => {
                                                                            return (
                                                                                <>
                                                                                    {getStatusToDisplay(status)} :{" "}
                                                                                    {apiBotReport?.statusWithTime[status]
                                                                                        ? calculateTime(apiBotReport?.statusWithTime[status])
                                                                                        : "-"}
                                                                                    <br />
                                                                                </>
                                                                            );
                                                                        })}
                                                                    </p>
                                                                }
                                                                className="cursor-pointer"
                                                            >
                                                                <InfoOutlinedIcon
                                                                    sx={{
                                                                        opacity: "50%",
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </Grid>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <NoRecords />
                    )}

                    {apiBotReportList.length > 0 && (
                        <Grid
                            className="my-2"
                            style={{
                                zIndex: "2",
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <Grid
                                style={{
                                    marginTop: "15px",
                                }}
                            >
                                Total Records: {totalCountPageSize}
                            </Grid>
                            <TablePaginationShowPage
                                rowsPerPageOptions={[5, 10, 25, 100]}
                                colSpan={3}
                                count={totalCountPageSize}
                                rowsPerPage={pageSize}
                                page={currentPage}
                                slotProps={{
                                    select: {
                                        "aria-label": "Rows per page",
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageRoundedIcon,
                                            lastPageIcon: LastPageRoundedIcon,
                                            nextPageIcon: ChevronRightRoundedIcon,
                                            backPageIcon: ChevronLeftRoundedIcon,
                                        },
                                    },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Grid>
                    )}
                </CardContent>
            </Card>

            {showApiBotSimulator && (
                <CampaignSimulator
                    open={showApiBotSimulator}
                    setShowCampaignSimulator={setShowApiBotSimulator}
                    campaignDetails={apiBotMessageDetails}
                    botDetails={selectedBot}
                    contentMessage={apiBotMessageDetails.messagePayload.payload.contentMessage}
                />
            )}
            {error.exists && (
                <AlertMessageComponent
                    message={error.message}
                    fieldName={"Download Report"}
                    handleClose={() => setError({ exists: false, message: "" })}
                    show={error.exists}
                />
            )}
        </Grid>
    );
}
